import type { ProductPermissionScopeCode } from '@/features/permission-and-role/constants/scope-code';
export type ForbiddenApiErrorAccessibles = {
  hasOperator: boolean;
  hasIndividual: boolean;
  hasPermissionScopes: ProductPermissionScopeCode[];
};

/**
 * Apiの403エラーを整形します
 * 例：
 * {
 *   "statusCode": 403,
 *   "timestamp": "2025-02-12T13:29:34.224Z",
 *   "systemMessage": "Forbidden",
 *   "accessibles": {
 *     "hasOperator": true,
 *     "hasIndividual": false
 *     "hasPermissionScopes": ["people", "device"]
 *   }
 * }
 */
export class ForbiddenApiError extends Error {
  public readonly accessibles: ForbiddenApiErrorAccessibles;
  constructor(accessibles: ForbiddenApiErrorAccessibles, message: string = 'Forbidden') {
    if (!accessibles) {
      // Error型はunknownになることが多いので、念の為
      throw new Error('accessibles is required');
    }
    if (!('hasOperator' in accessibles) || typeof accessibles.hasOperator !== 'boolean') {
      throw new Error('hasOperator is required');
    }
    if (!('hasIndividual' in accessibles) || typeof accessibles.hasIndividual !== 'boolean') {
      throw new Error('hasIndividual is required');
    }
    if (!('hasPermissionScopes' in accessibles) || !Array.isArray(accessibles.hasPermissionScopes)) {
      throw new Error('hasPermissionScopes is required');
    }
    super(message);
    this.name = 'ForbiddenApiError';
    this.accessibles = accessibles;
    Object.setPrototypeOf(this, ForbiddenApiError.prototype);
  }
}